<template>
  <BaseTypeNewForm
    base-type="offers"
    title="Neues Angebot anlegen"
    subtitle="Vergeben Sie einen Titel – Zeitraum, Inhalte und Vermarktung pflegen Sie anschließend im Editor."
    legend="Angebot benennen"
    input-label="Titel des Angebotes"
    hint="Tipp: Ein aussagekräftiger Titel hilft Gästen, Ihr Angebot in der Übersicht schneller wiederzufinden."
    submit-label="Angebot anlegen und bearbeiten"
    cancel-route-name="offers.index"
    :edit-route-name="editRouteName"
  />
</template>

<script>
import BaseTypeNewForm from "@/components/base_type/BaseTypeNewForm.vue";
import {ROUTES} from "@/stores/constants";

export default {
  components: {
    BaseTypeNewForm,
  },
  computed: {
    editRouteName() {
      return ROUTES.OFFERS.EDIT
    },
  },
}
</script>
